import React from "react";
import { Avatar, Box, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import IsMobile from "../../hooks/isMobile";
import { useAppSelector } from "../../hooks/storeHooks";
import ChatPageSendbirdChat from "../../components/pages-components/chat-page-components/ChatPageSendbirdChat/ChatPageSendbirdChat";
import ChatBackIcon from "../../assets/svg-fc/ChatBackIcon";
import youCaterAvatar from "../../assets/images/youCaterAvatar.png";
import { ROUTE_PATHS } from "../../routes";
import EmptyChatComponent from "../../components/pages-components/chat-page-components/ChatDetailHeader/EmptyChatComponent/EmptyChatComponent";
import { ConversationSkeleton } from "../../components/pages-components/chat-page-components/MessagingSkeleton/ConversationSkeleton";
import "./supportChat.scss";

const SupportChat: React.FC = () => {
	const isMobile = IsMobile();
	const navigate = useNavigate();
	const location = useLocation();
	const { adminVendorChatRecord, adminVendorChatRecordLoading } = useAppSelector((state) => state.chats);

	const handleGoBack = () => {
		navigate(`${ROUTE_PATHS.CHATS}${location.search}`);
	};

	const rendertSendBirdComponent = () => {
		if (!adminVendorChatRecord?.supportChannelUrl) return null;

		return (
			<Box className="chatDetailContentWrapper">
				<Box className="chatDetailContent">
					<ChatPageSendbirdChat
						showLatestIcon={true}
						channelUrl={adminVendorChatRecord.supportChannelUrl}
						isNewModelChannel={adminVendorChatRecord.isSupportSendbirdNewModel === true}
						vendorSendBirdId={adminVendorChatRecord.vendorSendBirdId}
						onMessageUpdates={() => {}}
					/>
				</Box>
			</Box>
		);
	};

	return (
		<Box className="catererChatDetailPage">
			{adminVendorChatRecordLoading ? (
				<ConversationSkeleton variant="support" />
			) : (
				<>
					{!adminVendorChatRecord && (
						<EmptyChatComponent
							onBackClick={() => {
								handleGoBack();
							}}
							emptyChatHeading={"No Messages"}
						/>
					)}
					{adminVendorChatRecord && (
						<Box className="chattingAndHeaderWrapper">
							<Box className="catererChatDetailsHeader">
								<Box className="chatDetailHeaderContent">
									<Box className="catererChatHeader">
										<Box className="chatHeaderAvatar">
											{isMobile && (
												<Box
													className="chatHeaderBackIcon"
													onClick={() => {
														handleGoBack();
													}}
												>
													<ChatBackIcon size="18" />
												</Box>
											)}
											<Avatar className="avatarBackground" src={youCaterAvatar} alt="vendor-logo" />
											<Typography className="adminName">YouCater Admin</Typography>
										</Box>
									</Box>
								</Box>
							</Box>
						</Box>
					)}
					{rendertSendBirdComponent()}
				</>
			)}
		</Box>
	);
};

export default SupportChat;
